import { Injectable } from '@angular/core';
import { BeaconWallet } from '@taquito/beacon-wallet';
import { TezosToolkit } from '@taquito/taquito';
import { defer, merge, Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const nodes = [
  'https://mainnet.api.tez.ie',
  'https://mainnet-tezos.giganode.io',
  'https://mainnet.smartpy.io',
  'https://teznode.letzbake.com',
  'https://mainnet-node.madfish.solutions',
];

@Injectable({
  providedIn: 'root',
})
export class WalletService {
  wallet: BeaconWallet;
  tezos: TezosToolkit;
  contractObject$: any;
  contract = environment.contract;

  constructor() {
    this.wallet = new BeaconWallet({
      name: 'Tezzardz',
    });
    this.tezos = new TezosToolkit(
      nodes[Math.floor(Math.random() * nodes.length)]
    );
    this.tezos.setWalletProvider(this.wallet);
  }

  userAddress(): Observable<string> {
    return defer(() => {
      return this.wallet.getPKH();
    });
  }

  userAddressCropped(): Observable<string> {
    return this.userAddress().pipe(
      map((address: any) => {
        return `${address.substring(0, 5)}...${address.slice(-5)}`;
      })
    );
  }

  hasPermission() {
    return localStorage.getItem('walletPermission');
  }

  getTezzardContract() {
    return this.getContractAt(this.contract);
  }

  getContractAt(contract: string) {
    return defer(() => {
      return this.tezos.wallet.at(contract);
    });
  }

  private clearPermission() {
    return localStorage.removeItem('walletPermission');
  }

  requestPermission() {
    this.wallet = new BeaconWallet({
      name: 'Tezzardz',
    });
    return defer(() => {
      return this.wallet.client.requestPermissions({
        network: {
          type: 'mainnet' as any,
        },
      });
    }).pipe(
      tap((_) => {
        this.tezos.setWalletProvider(this.wallet);
        localStorage.setItem('walletPermission', 'true');
      })
    );
  }

  getTezzardzAdopted(): Observable<number> {
    return this.getTezzardContract().pipe(
      mergeMap((contract) => {
        return contract.storage().then((storage) => {
          return (storage as any).n_minted.toNumber();
        });
      })
    );
  }

  desync() {
    return defer(() => {
      return merge(this.wallet.disconnect(), this.wallet.clearActiveAccount());
    }).pipe(
      tap((_) => {
        this.clearPermission();
      })
    );
  }
}
